import utils from '@/utils';

export default {
  install(Vue) {
    Vue.mixin({
      beforeCreate() {
        const options = this.$options;
        if (!options.computed) {
          options.computed = {};
        }
        if (options.computed.$utils) {
          return;
        }
        options.computed.$utils = () => {
          return utils;
        };
      },
    });
  },
};
